import { createSelector } from 'reselect';

export const selectPictures = (state) => state.get('entities').picture;

export const selectPictureById = createSelector(
  selectPictures,
  (state, pictureId) => pictureId,
  (pictures, pictureId) => pictures.get(pictureId)
);
